module.exports = __webpack_public_path__ + "static/img/MK@2x.33b25daf.jpg";